export function IframeVisualization({ data }: any) {
  return (
    <iframe
      title="PDF Viewer"
      src={`${data}`}
      width="fit-content"
      height="100%"
    />
  );
}
